module.exports = __webpack_public_path__ + "static/media/all-auctions-icon.8b0ed17c.jpg";